// byop.js (ImportPipeline)
//
// Entry point for importing a user's own Nextflow pipeline ("BYOP"). The one-shot
// GitHub/ZIP importer has been replaced by the guided, secure, resumable multi-step
// wizard in ./byop/ImportWizard.js (unified ZIP + GitHub). This thin wrapper keeps the
// existing /byop route and LandingPage tab working.
import React from "react";
import ImportWizard from "./byop/ImportWizard";

const ImportPipeline = () => <ImportWizard />;

export default ImportPipeline;
